import { createAction } from 'redux-actions';

import * as types from './actionTypes';

export const setActiveTab = createAction(types.SET_ACTIVE_TAB, (activeTab) => ({ activeTab }));
export const reset = createAction(types.RESET);
